// Standard library imports
import React, { useState, useContext, useEffect } from 'react';
// External library imports
import { useLocation, useHistory } from 'react-router-dom';

// Internal module imports
import TabsComponent from '../../../components/Tabs/Tabs';
import classes from './Admin.module.css';
import Admins from './Admins';
import CreateAdmin from './CreateAdmin';
import Roots from './Roots/Roots';
import CreateRoot from './Roots/CreateRoot';
import { AuthContext } from '../../../context/AuthContext';
import Enablers from './Enablers/Enablers';
import CreateEnabler from './Enablers/CreateEnabler';
import { tabCount } from '../../../utils/tabCount';
import { EICCodeService } from '../../../services/EICCodeService';
import { useLoader } from '../../../hooks';
import { BidCredentialsService } from '../../../services/BidCredentialsService';
import { NumberParam } from 'use-query-params';
import { useQueryParamWithDefault } from '../../../hooks';
import Onboarding from './Onboarding/Onboarding';

const getBidCredsByMaket = (data) => {
    const processedData = {};
    data?.data.forEach((key) => {
        const option = {
            label: key.name,
            value: key._id,
        };
        for (const market of key.market) {
            if (processedData[market]) {
                processedData[market].push(option);
            } else {
                processedData[market] = [option];
            }
        }
    });
    return processedData;
};

const Admin = ({ cId }) => {
    const [startLoader, stopLoader] = useLoader();
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const [queryParamsData] = useState({
        tab: queryParams.get('tab') ? Number(queryParams.get('tab')) : '',
    });
    const [createEditAdmin, setCreateEditAdmin] = useState({
        status: false,
        data: {},
    });
    const [createEditRoot, setCreateEditRoot] = useState({
        status: false,
        data: {},
    });
    const [createEditEnabler, setCreateEditEnabler] = useState({
        status: false,
        data: {},
    });
    const [allAdmins, setAllAdmins] = useState([]);
    const [EICCodes, setEICCodes] = useState([]);
    const [bidCredentialsMarket, setBidCredentialsMarket] = useState({});

    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);
    const { state } = useContext(AuthContext);

    useEffect(() => {
        fetchEICCodes();
        fetchBiddingCredentials();
    }, []);

    const fetchEICCodes = () => {
        EICCodeService.ReadAll(
            () => startLoader('getEICCodes'),
            handleSuccess,
            handleError,
            () => stopLoader('getEICCodes')
        );
    };

    const fetchBiddingCredentials = () => {
        BidCredentialsService.ReadAll(
            () => startLoader('getCreds'),
            handleBidCredentialsSuccess,
            handleError,
            () => stopLoader('getCreds')
        );
    };

    const handleError = (error) => {
        console.log(error);
    };

    const handleSuccess = ({ data }) => {
        const processedData = data?.data.map((key) => {
            return {
                label: key.name,
                value: key.EICCode,
            };
        });
        setEICCodes([{ label: 'None', value: '' }, ...processedData]);
    };

    const handleBidCredentialsSuccess = ({ data }) => {
        const processedData = getBidCredsByMaket(data);
        setBidCredentialsMarket(processedData);
    };

    const updateQueryParams = (type, value) => {
        queryParams.set(type, value);
        history.push({ search: queryParams.toString() });
    };
    const tabslength = state?.user?.userRole === 'root-admin' ? 3 : state?.user?.userRole == 'root' ? 4 : tabCount(location.pathname, state);

    const tabs = [
        {
            name: 'Admins',
            component: <Admins setCreateEditAdmin={setCreateEditAdmin} setSelectedIndex={setSelectedIndex} tabslength={tabslength} />,
            tabId: 1,
        },
        ...(state?.user?.userRole == 'root' || state?.user?.userRole === 'root-admin'
            ? [
                  {
                      name: 'Enabler',
                      component: (
                          <Enablers setCreateEditEnabler={setCreateEditEnabler} setSelectedIndex={setSelectedIndex} tabslength={tabslength} updateQueryParams={updateQueryParams} />
                      ),
                      tabId: 2,
                  },
              ]
            : []),
        ...(state?.user?.userRole == 'root'
            ? [
                  {
                      name: 'Root',
                      component: <Roots setCreateEditRoot={setCreateEditRoot} setSelectedIndex={setSelectedIndex} tabslength={tabslength} />,
                      tabId: 3,
                  },
              ]
            : []),
        {
            name: 'Onboarding',
            component: <Onboarding tabslength={tabslength} />,
            tabId: 4,
        },
        ...(createEditAdmin.status
            ? [
                  {
                      name: `${createEditAdmin.data?._id ? 'Edit' : 'Create'} Admin`,
                      component: <CreateAdmin adminData={createEditAdmin.data} EICCodes={EICCodes} bidCredentialsMarket={bidCredentialsMarket} />,
                      tabId: 1,
                  },
              ]
            : []),
        ...(createEditRoot.status
            ? [
                  {
                      name: `${createEditRoot.data?._id ? 'Edit' : 'Create'} Root`,
                      component: (
                          <CreateRoot
                              rootData={createEditRoot.data}
                              // setSelectedIndex={setSelectedIndex}
                          />
                      ),
                      tabId: 3,
                  },
              ]
            : []),
        ...(createEditEnabler.status
            ? [
                  {
                      name: `${createEditEnabler.data?._id ? 'Edit' : 'Create'} Enabler`,
                      component: (
                          <CreateEnabler
                              enablerData={createEditEnabler.data}
                              // setSelectedIndex={setSelectedIndex}
                          />
                      ),
                      tabId: 2,
                  },
              ]
            : []),
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                setEditGroup={() => {
                    setCreateEditAdmin({ status: false, data: {} });
                    setCreateEditEnabler({ status: false, data: {} });
                }}
                setEditDevice={() => {
                    setCreateEditRoot({ status: false, data: {} });
                }}
                onChangeTab={setSelectedIndex}
                cId={cId}
            />
        </div>
    );
};

export default Admin;
